import { render, staticRenderFns } from "./GuideItem.vue?vue&type=template&id=19869517&scoped=true"
import script from "./GuideItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./GuideItem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./GuideItem.vue?vue&type=style&index=0&id=19869517&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19869517",
  null
  
)

export default component.exports